export default {
  summaryList: {
    path: {
      summaryDetail: '结算汇总表详情',
    },
    search: {
      summaryCompanyNo: '公司',
      summaryDepartmentNo: '事业部门',
      orderNo: '业务订单',
      settleNo: '结算批次编号',
      settleDesc: '结算批次描述',
      supplierNo: '供应链主体',
      settleType: '结算类型',
      productNo: '商品编码',
      productDesc: '商品描述',
      settleCreateDateStart: '创建日期起',
      settleCreateDateEnd: '创建日期止',
    },
    table: {
      totalSum: '合计',
      littleSum: '小计',
      id: '序号',
      summaryCompanyName: '公司',
      summaryDepartmentName: '事业部门',
      orderNo: '业务订单',
      settleNo: '结算批次编号',
      settleDesc: '结算批次描述',
      slipStatusName: '结算单状态',
      deliveryQuantity: '发货数量',
      ladingQuantity: '开单数量',
      availableLadingQuantity: '可开单库存数量',
      unexecutedSalesContractQuantity: '未执行销售合同数量',
      availableSalesStorageQuantity: '可售库存数量',
      payedGoodsAmount: '已付货款',
      payedExpenseAmount: '已付费用',
      benchmarkRate: '基准税率(%)',
      taxDifference: '税差',
      receivableInterest: '应收利息',
      soldReceivableAmount: '已售应收款',
      receivedAmount: '已收款',
      soldUnreceivedAmount: '已售未收',
      settleBatchMarginMoney: '结算批次保证金',
      returnedMarginMoney: '已返保证金',
      restMarginMoney: '剩余保证金',
      settleBatchProfit: '结算批次利润',
      returnedProfit: '已返利润',
      restProfit: '剩余利润',
      purchaseAvgPrice: '采购均价',
      detainMarginMoneyPercent: '理论应扣留保证金比例(%)',
      detainMarginMoneyAmount: '理论应扣留保证金',
      returnableMarginMoney: '可返保证金',
      storageAmount: '库存金额',
      unpayedExpenseAmount: '应付未付费用',
      soldDeliveryRate: '已售数量/发运数量',
      serviceTariffing: '平台服务费利率',
      serviceAmount: '平台服务费',
    },
    message: {
      dateVerify: '起止日期不能为空，请选择起止日期！',
      createSummarySuccess: '生成结算汇总表成功',
    },
  },
  summaryDetail: {
    title: '结算汇总表详情',
    tabsName: {
      procurement: '采购合同明细',
      putInStorage: '业务入库单明细',
      payment: '付款明细',
      salesContract: '销售明细',
      ladingBill: '提单明细',
      collection: '收款明细',
      cost: '费用明细',
      fundsInterests: '资金利息',
    },
  },
};
